import {
  nav,
  div,
  label,
  span,
  button,
  img,
  goTo
} from '@srfnstack/fntags'
import { user, credits, refreshCredits } from '../state.js'
import { fnfetch } from '../fetch.js'
import { ALPHA_WHITELIST } from '../utils/alpha.js'

export const Navbar = () => nav({
  class: 'navbar border-b border-base-300 sticky top-0 z-40 relative',
  style: 'background-color: #282f3f'
},
div({ class: 'flex-none lg:hidden' },
  label({ for: 'app-drawer', class: 'btn btn-square btn-ghost' },
    span({ class: 'icon material-symbols-rounded' }, 'menu')
  )
),
div({ class: 'absolute left-1/2 -translate-x-1/2 lg:hidden' },
  img({ src: '/images/etherbuildr_logo.png', alt: 'EtherBuildr', style: 'height: 40px;' })
),
div({ class: 'flex-1' }),
div({ class: 'flex-none hidden lg:block' },
  user.bindAs(u => ALPHA_WHITELIST.includes(u.email)
    ? button({
      class: 'btn btn-outline btn-accent btn-sm mr-4',
      onclick: async () => {
        const res = await fnfetch('/api/system/alpha-credits', { method: 'POST' })
        if (res.ok) {
          await refreshCredits()
        }
      }
    }, 'Give Me More Credits')
    : ''
  ),
  div({ class: 'stats shadow bg-base-100 mr-4' },
    div({
      class: 'stat py-1 px-3 cursor-pointer hover:bg-base-200 transition-colors',
      onclick: () => goTo('/billing/buy-credits')
    },
    div({ class: 'stat-title text-xs flex items-center gap-1' },
      span({ class: 'material-symbols-rounded text-xs' }, 'token'),
      'Credits'
    ),
    div({ class: 'stat-value text-sm text-primary' }, credits.bindAs())
    )
  ),
  button({
    class: 'btn btn-primary btn-sm mr-2',
    onclick: () => goTo('/billing/buy-credits')
  },
  span({ class: 'material-symbols-rounded text-sm' }, 'add_circle'),
  'Top Up'
  ),
  button({
    class: 'btn btn-ghost btn-sm',
    onclick: async () => {
      await fnfetch('/api/auth/logout', { method: 'POST' })
      user({ loggedIn: false })
      window.location.href = '/login'
    }
  }, 'Logout')
)
)
